import { TFunction } from 'react-i18next';
import { Currency, formatCurrency, formatDate } from '@chargify/formatters';
import { Coupon } from '../../models/subscription/types';

export function formatCouponValue(
  { percentage, amountInCents }: Coupon,
  currency: Currency
) {
  return percentage
    ? `-${percentage}%`
    : `-${formatCurrency(currency, amountInCents)}`;
}

export function getCouponDescription(
  coupon: Coupon,
  t: TFunction<'subscriptions-manager'[]>
) {
  if (coupon.recurring) {
    return coupon.expiresAt
      ? t('coupons.recurring_with_expiration', {
          date: formatDate(coupon.expiresAt),
        })
      : t('coupons.recurring');
  }
  return t('coupons.one_time');
}
